module.exports = __webpack_public_path__ + "static/img/clock.247c862b.svg";